export default {
  year: 2025,
  contests: [
    {
      title: "2025 ICPC Asia Seoul Regional Contest",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["32", "7", "goraani", "강효규, 김동건, 조원빈"],
      ],
      award: [""],
      links: [
        ["공식 사이트", "https://icpckorea.org/2025-seoul/regional"],
        ["스코어보드", "http://static.icpckorea.net/2025/regional/scoreboard"],
      ],
      review: [],
    },
    {
      title: "NYPC 2025 Code Battle",
      columns: ["#", "팀", "멤버"],
      data: [
        ["-", "티미름", "이재혁, 강효규, 김서인, 김진수"],
      ],
      award: [""],
      links: [
        ["공식 사이트", "https://battle.nypc.co.kr/ko"],
      ],
      review: [],
    },
    {
      title: "2025 ICPC Asia Seoul Preliminary Contest",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["14", "6", "goraani", "강효규, 김동건, 조원빈"],
        ["67", "3", "LittlEHearTs", "양제웅, 김규민, 노주환"],
        ["68", "3", "RetroS", "김태윤, 박준우, 이재찬"],
        ["69", "3", "busan vacance", "김진수, 조성훈, 이재혁"],
        ["123", "2", "998244353", "전현길, 천우영, 박준영"],
        ["148", "2", "Nice yongju", "최용주, 김태우, 박시영"],
        ["159", "2", "Rice Diggers", "김홍래, 한정우, 김태영"],
        ["172", "1", "Nun Nu Nan Na", "이준호, 이채령, 이수성"],
        ["178", "1", "SUHAN GWA IDLE", "권수한, 문수연, 김서연"],
        ["180", "1", "starstarstar", "김윤하, 유승훈, 이준우"],
        ["192", "1", "CSS", "함민식, 이진호, 김태현"],
      ],
      award: ["advanced", "", "", "", "", "", "", "", "", "", ""],
      links: [
        ["공식 사이트", "http://icpckorea.org/2025-seoul/regional"],
        ["스코어보드", "http://static.icpckorea.net/2025/preliminary/scoreboard"],
      ],
      review: [],
    },
    {
      title: "LG Collegiate Programming Contest 2025",
      columns: ["#", "이름"],
      data: [
        ["16", "강효규"],
      ],
      award: [""],
      links: [
        ["공식 사이트", "https://www.lgsdc.com/program/lgcpc.php"],
        ["스코어보드", "https://www.acmicpc.net/contest/board/1570"],
      ],
      review: [],
    },
    {
      title: "SUAPC 2025 Summer",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["2", "10", "오락실거주중인고양이들", "채성우, 박성준, 노주환"],
        ["3", "8", "공공면면공공", "박준영, 길수민(ALGOS), 박경욱(MOLGO)"],
        ["4", "8", "goraani never dies", "김동건, 강효규, 조원빈"],
        ["6", "7", "LLM", "김진수, 이재혁, 하건영"],
        ["8", "6", "Retros", "김태윤, 이재찬, 박준우"],
        ["10", "6", "치군공", "정재헌, 박동언(MOLGO), 이지훈"],
      ],
      award: ["gold", "gold", "silver", "silver", "bronze", "bronze"],
      links: [
        ["공식 사이트", "https://icpc-sinchon.io/suapc"],
        ["스코어보드", "https://www.acmicpc.net/contest/spotboard/1538"],
      ],
      review: [],
    },
    {
      title: "UCPC 2025 본선",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["18", "5", "goraani never dies", "강효규, 김동건, 조원빈"],
        ["19", "5", "조민수의새로운데스크디자인하마지아키블루아카데스크테리어세트", "채성우, 박성준, 박용한(SSU)"],
        ["57", "2", "LittlEHearTs", "김규민, 노주환, 양제웅"],
      ],
      award: ["", "", ""],
      links: [
        ["공식 사이트", "https://ucpc.me"],
        ["스코어보드", "https://www.acmicpc.net/contest/spotboard/1531"],
      ],
      review: [],
    },
    {
      title: "2025 ICPC Asia Pacific Championship",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["38", "5", "AllTimeLegend", "박성준, 송근수, 이승형"],
        ["46", "4", "Redshift", "박수현, 조원빈, 채성우"],
      ],
      award: ["", ""],
      links: [
        ["공식 사이트", "https://apac.icpc.global"],
        ["스코어보드", "https://icpc.global/regionals/finder/APSEPC-2025/standings"],
      ],
      review: [],
    },
    {
      title: "SUAPC 2025 Winter",
      columns: ["#", "=", "팀", "멤버"],
      data: [
        ["2", "12", "배신저스", "송근수, 강효규, 채성우"],
        ["3", "11", "나근육또녹을지도", "김동건, 이승형, 조원빈"],
        ["5", "11", "calientacabezas", "최환, 정재헌, 박동언(MOLGO)"],
        ["6", "11", "공면공", "박경욱(MOLGO), 길수민(ALGOS), 박준영"],
        ["8", "9", "chill솔 못 했지만 chill하게 한 잔 하는 chill guy들", "김진수, 조성훈, 하건영"],
        ["9", "8", "우리팀명 뭐로할래", "김규민, 양제웅, 이승찬"],
      ],
      award: ["gold", "gold", "silver", "bronze", "bronze"],
      links: [
        ["공식 사이트", "https://icpc-sinchon.io/suapc"],
        ["스코어보드", "https://www.acmicpc.net/contest/spotboard/1449"],
      ],
      review: [],
    },
  ],
};
